import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const BackupPaymentMethods = gql`
  ${error}
  query advanceBackupPaymentMethods {
    advanceBackupPaymentMethods {
      __typename

      ... on AdvanceBackupPaymentMethods {
        methods {
          detail
          icon {
            ... on URLType {
              __typename
              url
            }
            ... on VXLIconType {
              __typename
              key
            }
          }
          mask
          name
          placeholder
        }
      }
      ... on AdvanceBackupPaymentMethodsError {
        __typename
        ...error
      }
    }
  }
`;

export default BackupPaymentMethods;
